import { Link } from 'react-router';
import { DocumentMeta } from '../hooks/useDocumentMeta';

export default function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8" style={{ fontFamily: 'var(--font-secondary)' }}>
      <DocumentMeta title="Politica de Confidențialitate" />
      <h1 className="mb-6 text-3xl font-bold" style={{ color: 'var(--vivid-purple)', fontFamily: 'var(--font-primary)' }}>
        Politica de Confidențialitate
      </h1>
      <p className="mb-4 text-sm text-muted-foreground">Ultima actualizare: 20/03/2026 · Versiunea 1.0</p>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>1. Operatorul de Date</h2>
        <p className="mb-2">
          <strong>Asociația Eu Sunt</strong><br />
          CIF: 34347234<br />
          Adresă: Calea Moților, nr. 24, Alba Iulia, jud. Alba<br />
          Email: <a href="mailto:contact.ctro@albaiulia2026.ro" className="text-[var(--vivid-purple)] underline">contact.ctro@albaiulia2026.ro</a>
        </p>
        <p>
          Asociația Eu Sunt este operatorul datelor cu caracter personal colectate prin platforma
          Alba Iulia — Capitala Tineretului din România 2026.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>2. Procesatori / Împuterniciți</h2>

        <div className="mb-4">
          <h3 className="mb-1 font-semibold">Găzduire (AWS)</h3>
          <p>
            <strong>Asociația Centrul Local Axente Sever Alba Iulia</strong>, filială a Organizației Naționale Cercetașii România<br />
            CIF: 11197758<br />
            Adresă: Str. Ana Aslan, nr. 39, Alba Iulia, jud. Alba
          </p>
        </div>

        <div>
          <h3 className="mb-1 font-semibold">Dezvoltare și administrare tehnică</h3>
          <p>
            <strong>YetiLabs SRL</strong><br />
            CIF: 44237638<br />
            Adresă: Bd. Transilvaniei, nr. 25, bl. 3CD, ap. 22, Alba Iulia
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>3. Date Colectate și Scopul Prelucrării</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="py-2 pr-4 text-left font-semibold">Dată colectată</th>
                <th className="py-2 pr-4 text-left font-semibold">Scop</th>
                <th className="py-2 text-left font-semibold">Temei legal</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 pr-4">Nume</td>
                <td className="py-2 pr-4">Identificare, comunicare, înregistrare la activități</td>
                <td className="py-2">Art. 6 alin. 1 lit. b GDPR — executarea unui serviciu</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 pr-4">Email</td>
                <td className="py-2 pr-4">Autentificare, comunicare, înregistrare la activități</td>
                <td className="py-2">Art. 6 alin. 1 lit. b GDPR — executarea unui serviciu</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 pr-4">Data nașterii</td>
                <td className="py-2 pr-4">Verificare vârstă: minori vs. adulți, restricție &lt;35 ani pentru activități dedicate tinerilor</td>
                <td className="py-2">Art. 6 alin. 1 lit. f GDPR — interes legitim</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 pr-4">Telefon (opțional)</td>
                <td className="py-2 pr-4">Contact în legătură cu activitățile la care participi</td>
                <td className="py-2">Art. 6 alin. 1 lit. a GDPR — consimțământ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>4. Durata Stocării</h2>
        <p>
          Datele personale sunt stocate pe durata existenței contului tău. După ștergerea contului,
          datele sunt anonimizate în termen de 30 de zile. Datele anonimizate pot fi păstrate
          în scopuri statistice.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>5. Drepturile Tale</h2>
        <p className="mb-2">Conform GDPR, ai următoarele drepturi:</p>
        <ul className="list-inside list-disc space-y-1">
          <li><strong>Dreptul de acces</strong> — poți descărca toate datele tale din secțiunea <Link to="/cont" className="text-[var(--vivid-purple)] underline">Contul Meu</Link></li>
          <li><strong>Dreptul la rectificare</strong> — poți edita datele personale din profil</li>
          <li><strong>Dreptul la ștergere</strong> — poți șterge contul din secțiunea Contul Meu</li>
          <li><strong>Dreptul la restricționarea prelucrării</strong></li>
          <li><strong>Dreptul la portabilitatea datelor</strong> — export în format JSON</li>
          <li><strong>Dreptul la opoziție</strong></li>
          <li><strong>Dreptul de retragere a consimțământului</strong> — în orice moment, fără a afecta legalitatea prelucrării anterioare</li>
        </ul>
        <p className="mt-3">
          Pentru exercitarea acestor drepturi, contactează-ne la{' '}
          <a href="mailto:contact.ctro@albaiulia2026.ro" className="text-[var(--vivid-purple)] underline">contact.ctro@albaiulia2026.ro</a>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>6. Partajarea Datelor cu Organizatorii de Activități</h2>
        <p className="mb-2">
          Când te înscrii la o activitate organizată de un partener, următoarele date personale sunt
          partajate cu organizatorul respectiv:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>Nume și prenume</li>
          <li>Adresă de email</li>
          <li>Număr de telefon</li>
          <li>Vârstă (calculată din data nașterii)</li>
        </ul>
        <p className="mt-2">
          <strong>Temei legal:</strong> Consimțământ explicit (art. 6 alin. 1 lit. a GDPR) — ești informat
          la momentul înscrierii despre partenerii cu care vor fi partajate datele și trebuie să
          consimți explicit.
        </p>
        <p className="mt-2">
          Partenerii organizatori sunt legați prin Acorduri de Prelucrare a Datelor (DPA) cu operatorul
          și au obligația de a prelucra datele exclusiv în scopul organizării activității. Accesul
          partenerilor la datele participanților expiră la 30 de zile după încheierea activității.
        </p>
        <p className="mt-2">
          Lista partenerilor organizatori nu este exhaustivă — noi parteneri pot fi adăugați pe durata
          programului. Vei fi informat despre partenerii specifici la momentul fiecărei înscrieri.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>7. Cookies și Servicii Terțe</h2>
        <p className="mb-2">Platforma utilizează:</p>
        <ul className="list-inside list-disc space-y-1">
          <li><strong>Cookies esențiale</strong> — pentru autentificare și funcționarea platformei</li>
          <li><strong>Google Analytics (GA4)</strong> — pentru analiza traficului, doar cu consimțământul tău</li>
          <li><strong>Sentry</strong> — pentru monitorizarea erorilor, doar cu consimțământul tău</li>
        </ul>
        <p className="mt-2">
          Pentru detalii, consultă <Link to="/cookies" className="text-[var(--vivid-purple)] underline">Politica de Cookies</Link>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>8. Transferuri Internaționale</h2>
        <p>
          Datele pot fi procesate prin servicii cu servere în UE/SEE (Amazon Web Services — regiune EU).
          Google Analytics și Sentry pot transfera date în afara UE, sub protecția clauzelor contractuale
          standard aprobate de Comisia Europeană.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>9. Minori</h2>
        <p>
          Conform legislației române (GDPR, art. 8 + Legea 190/2018), persoanele sub 16 ani necesită
          consimțământul părintelui sau tutorelui legal pentru crearea unui cont și prelucrarea datelor personale.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>10. Plângeri</h2>
        <p>
          Dacă consideri că datele tale nu sunt prelucrate conform legii, ai dreptul de a depune o plângere la
          Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP) —{' '}
          <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="text-[var(--vivid-purple)] underline">
            www.dataprotection.ro
          </a>.
        </p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>11. Contact</h2>
        <p>
          Pentru orice întrebări legate de protecția datelor personale, ne poți contacta la:<br />
          <a href="mailto:contact.ctro@albaiulia2026.ro" className="text-[var(--vivid-purple)] underline">contact.ctro@albaiulia2026.ro</a>
        </p>
      </section>
    </div>
  );
}
